<script setup lang="ts">
import { ref } from "vue";
import { Loader } from "@googlemaps/js-api-loader"
import { onMounted } from "vue"; // this is for my next step

const placeInput = ref<HTMLInputElement>();

const emit = defineEmits([
  'placeChanged'
])

onMounted(async (callback: ((this: MediaQueryList, ev: MediaQueryListEvent) => any) | null) => {

  const loader = new Loader({
    apiKey: window.Laravel.gmapApiKey,
    version: "weekly",
  });

  console.log('loader', loader);//optional logging

  const Places = await loader.importLibrary('places')


  console.log('placeInput', placeInput, placeInput.value); //optional logging
  // get the input element

  const autocomplete = new Places.Autocomplete(placeInput.value, {});

  autocomplete.addListener('place_changed', () => {
    const place = autocomplete.getPlace(); //this callback is inherent you will see it if you logged autocomplete
    emit('placeChanged', place)
  });
});

</script>

<template>
  <input ref="placeInput" type="text" v-bind="$attrs"/>
</template>

<style>
/* Ensure the autocomplete dropdown appears above other elements (to fix problems with modals, etc.) */
div.pac-container {
  position: absolute !important;
  z-index: 999999 !important;
  pointer-events: auto !important;
}

/* Sometimes useful if the overlay intercepts clicks outside the Dialog */
[data-radix-popper-content-wrapper],
[data-dialog-overlay],
[data-dialog-content] {
  pointer-events: auto;
}
</style>